export default __webpack_public_path__ + "static/media/sn3.665ee8e9.jpg";